/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProjectChannelMessage } from '../models/project-channel-message';
import { ProjectChannelMessageSendChannelMessageRequestDto } from '../models/project-channel-message-send-channel-message-request-dto';
import { ProjectChannelMessageSendChannelMessageResponseDto } from '../models/project-channel-message-send-channel-message-response-dto';
import { ProjectChannelMessageSendDirectMessageRequestDto } from '../models/project-channel-message-send-direct-message-request-dto';
import { ProjectChannelMessageSendDirectMessageResponseDto } from '../models/project-channel-message-send-direct-message-response-dto';

@Injectable({
  providedIn: 'root',
})
export class ProjectChannelMessageControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation projectChannelMessageControllerSendChannelMessageByApiKey
   */
  static readonly ProjectChannelMessageControllerSendChannelMessageByApiKeyPath = '/api-key/project-channel-messages/channel-messages/send';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendChannelMessageByApiKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendChannelMessageByApiKey$Response(params?: {
    body?: ProjectChannelMessageSendChannelMessageRequestDto
  }): Observable<StrictHttpResponse<ProjectChannelMessageSendChannelMessageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelMessageControllerService.ProjectChannelMessageControllerSendChannelMessageByApiKeyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectChannelMessageSendChannelMessageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendChannelMessageByApiKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendChannelMessageByApiKey(params?: {
    body?: ProjectChannelMessageSendChannelMessageRequestDto
  }): Observable<ProjectChannelMessageSendChannelMessageResponseDto> {

    return this.sendChannelMessageByApiKey$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectChannelMessageSendChannelMessageResponseDto>) => r.body as ProjectChannelMessageSendChannelMessageResponseDto)
    );
  }

  /**
   * Path part for operation projectChannelMessageControllerFindChannelMessagesByApiKey
   */
  static readonly ProjectChannelMessageControllerFindChannelMessagesByApiKeyPath = '/api-key/project-channel-messages/channel-messages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findChannelMessagesByApiKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  findChannelMessagesByApiKey$Response(params?: {
    channelId?: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ProjectChannelMessage>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelMessageControllerService.ProjectChannelMessageControllerFindChannelMessagesByApiKeyPath, 'get');
    if (params) {
      rb.query('channelId', params.channelId, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectChannelMessage>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findChannelMessagesByApiKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findChannelMessagesByApiKey(params?: {
    channelId?: string;
    filter?: any;
  }): Observable<Array<ProjectChannelMessage>> {

    return this.findChannelMessagesByApiKey$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectChannelMessage>>) => r.body as Array<ProjectChannelMessage>)
    );
  }

  /**
   * Path part for operation projectChannelMessageControllerSendDirectMessageByApiKey
   */
  static readonly ProjectChannelMessageControllerSendDirectMessageByApiKeyPath = '/api-key/project-channel-messages/direct-messages/send';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendDirectMessageByApiKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendDirectMessageByApiKey$Response(params?: {
    body?: ProjectChannelMessageSendDirectMessageRequestDto
  }): Observable<StrictHttpResponse<ProjectChannelMessageSendDirectMessageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelMessageControllerService.ProjectChannelMessageControllerSendDirectMessageByApiKeyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectChannelMessageSendDirectMessageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendDirectMessageByApiKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendDirectMessageByApiKey(params?: {
    body?: ProjectChannelMessageSendDirectMessageRequestDto
  }): Observable<ProjectChannelMessageSendDirectMessageResponseDto> {

    return this.sendDirectMessageByApiKey$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectChannelMessageSendDirectMessageResponseDto>) => r.body as ProjectChannelMessageSendDirectMessageResponseDto)
    );
  }

  /**
   * Path part for operation projectChannelMessageControllerFindDirectMessagesByApiKey
   */
  static readonly ProjectChannelMessageControllerFindDirectMessagesByApiKeyPath = '/api-key/project-channel-messages/direct-messages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findDirectMessagesByApiKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDirectMessagesByApiKey$Response(params?: {
    receiverId?: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ProjectChannelMessage>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelMessageControllerService.ProjectChannelMessageControllerFindDirectMessagesByApiKeyPath, 'get');
    if (params) {
      rb.query('receiverId', params.receiverId, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectChannelMessage>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findDirectMessagesByApiKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDirectMessagesByApiKey(params?: {
    receiverId?: string;
    filter?: any;
  }): Observable<Array<ProjectChannelMessage>> {

    return this.findDirectMessagesByApiKey$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectChannelMessage>>) => r.body as Array<ProjectChannelMessage>)
    );
  }

  /**
   * Path part for operation projectChannelMessageControllerSendChannelMessage
   */
  static readonly ProjectChannelMessageControllerSendChannelMessagePath = '/project-channel-messages/channel-messages/send';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendChannelMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendChannelMessage$Response(params?: {
    body?: ProjectChannelMessageSendChannelMessageRequestDto
  }): Observable<StrictHttpResponse<ProjectChannelMessageSendChannelMessageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelMessageControllerService.ProjectChannelMessageControllerSendChannelMessagePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectChannelMessageSendChannelMessageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendChannelMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendChannelMessage(params?: {
    body?: ProjectChannelMessageSendChannelMessageRequestDto
  }): Observable<ProjectChannelMessageSendChannelMessageResponseDto> {

    return this.sendChannelMessage$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectChannelMessageSendChannelMessageResponseDto>) => r.body as ProjectChannelMessageSendChannelMessageResponseDto)
    );
  }

  /**
   * Path part for operation projectChannelMessageControllerFindChannelMessages
   */
  static readonly ProjectChannelMessageControllerFindChannelMessagesPath = '/project-channel-messages/channel-messages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findChannelMessages()` instead.
   *
   * This method doesn't expect any request body.
   */
  findChannelMessages$Response(params?: {
    channelId?: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ProjectChannelMessage>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelMessageControllerService.ProjectChannelMessageControllerFindChannelMessagesPath, 'get');
    if (params) {
      rb.query('channelId', params.channelId, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectChannelMessage>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findChannelMessages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findChannelMessages(params?: {
    channelId?: string;
    filter?: any;
  }): Observable<Array<ProjectChannelMessage>> {

    return this.findChannelMessages$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectChannelMessage>>) => r.body as Array<ProjectChannelMessage>)
    );
  }

  /**
   * Path part for operation projectChannelMessageControllerSendDirectMessage
   */
  static readonly ProjectChannelMessageControllerSendDirectMessagePath = '/project-channel-messages/direct-messages/send';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendDirectMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendDirectMessage$Response(params?: {
    body?: ProjectChannelMessageSendDirectMessageRequestDto
  }): Observable<StrictHttpResponse<ProjectChannelMessageSendDirectMessageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelMessageControllerService.ProjectChannelMessageControllerSendDirectMessagePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectChannelMessageSendDirectMessageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendDirectMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendDirectMessage(params?: {
    body?: ProjectChannelMessageSendDirectMessageRequestDto
  }): Observable<ProjectChannelMessageSendDirectMessageResponseDto> {

    return this.sendDirectMessage$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectChannelMessageSendDirectMessageResponseDto>) => r.body as ProjectChannelMessageSendDirectMessageResponseDto)
    );
  }

  /**
   * Path part for operation projectChannelMessageControllerFindDirectMessages
   */
  static readonly ProjectChannelMessageControllerFindDirectMessagesPath = '/project-channel-messages/direct-messages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findDirectMessages()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDirectMessages$Response(params?: {
    receiverId?: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ProjectChannelMessage>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectChannelMessageControllerService.ProjectChannelMessageControllerFindDirectMessagesPath, 'get');
    if (params) {
      rb.query('receiverId', params.receiverId, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectChannelMessage>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findDirectMessages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDirectMessages(params?: {
    receiverId?: string;
    filter?: any;
  }): Observable<Array<ProjectChannelMessage>> {

    return this.findDirectMessages$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectChannelMessage>>) => r.body as Array<ProjectChannelMessage>)
    );
  }

}
